import { Outlet } from 'react-router';

import { HeroBanner, ScrollToTop, Stepper } from '@/components';

const BookingLayout: React.FC = () => {
  return (
    <div className="min-h-screen">
      <ScrollToTop />
      {/* Upper part - Hero Banner and Stepper */}
      <div>
        <HeroBanner />
        <Stepper />
      </div>

      {/* Lower part - Step content */}
      <div className="container mx-auto px-4 py-8">
        <Outlet />
      </div>
    </div>
  );
};

export default BookingLayout;
